import MaintenanceRepository from "@/js/repositories/MaintenanceRepository"

const state = {
    startDateTime: null,
    endDateTime: null,
    message: "",
    isMaintenance: false // New state to track if the service is under maintenance
}

const getters = {}

const actions = {
    initMaintenance({ commit }) {
        commit("INIT")
    },
    setMaintenance({ commit }, data) {
        commit("MAINTENANCE", data)
    },
    async checkStillMaintenance({ commit }) {
        const response = await MaintenanceRepository.checkMaintenanceAsync()
        if (response.maintenance === false) {
            console.log("No maintenance mode")
            commit("INIT")
            return false
        } else {
            // Already handle in Repository cache error
            console.log("Already in maintenance mode")
            return true
        }
    }
}

const mutations = {
    INIT(state) {
        state.startDateTime = null
        state.endDateTime = null
        state.message = ""
        state.isMaintenance = false // Reset maintenance state
    },
    MAINTENANCE(state, data) {
        state.startDateTime = data.startDateTime
        state.endDateTime = data.endDateTime
        state.message = data.message
        state.isMaintenance = data.isMaintenance // Update maintenance state
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
